<div>
  <app-dashboard-menu></app-dashboard-menu>
 
<div class="card">
<div class="PerformanceTrendModalBody">
<!-- <div class="dashboardContentBox"> -->

        <div class="selectPeriodPan selectPeriodModal col-sm-12 col-xs-12 col-md-3 col-lg-3">
            <app-report-filter (outputData)="addItem($event)" [reportName]="'newCustomerRegistrationReport'"></app-report-filter>  
        </div> 
       
        <div class="col-sm-12 col-xs-12 col-md-5 col-lg-9" style="display: block">

          <canvas baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [options]="barChartOptions"
                  [colors]="barChartColors"          
                  [chartType]="barChartType"
                  (chartHover)="chartHovered($event)"
                  (chartClick)="chartClicked($event)"></canvas>

        </div>
 <!-- </div> -->
  </div> 
</div>

</div>